<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="organiza-txt">
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.username">{{item.username}}</p>
              <p :title="item.problem_type==1?'功能异常':item.problem_type==2?'体验问题':item.problem_type==3?'题目问题':item.problem_type==4?'题目问题':problem_type==5?'新功能建议':'其他'">{{item.problem_type==1?'功能异常':item.problem_type==2?'体验问题':item.problem_type==3?'题目问题':item.problem_type==4?'题目问题':problem_type==5?'新功能建议':'其他'}}</p>
              <p :title="item.problem_content">{{item.problem_content}}</p>
              <p :title="item.first_image">
                <img :src="'https://pic.speechcoach.cn/'+item.first_img" alt=""></img>
              </p>
              <p :title="item.add_time">{{item.add_time}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFeedbackList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'8',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户昵称'},
        {id:3,title:'问题类型'},
        {id:4,title:'问题内容'},
        {id:5,title:'问题图片'},
        {id:6,title:'添加时间'},
        // {id:7,title:'操作'},
      ],
      dataList:[
      ],
      token:'',
      obj:{
        page:1,
        rows:10
      },
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getFeedbackList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },
  }
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
    padding: 21px 10px;
  }

  .dataList .listItem p.btnList{
    font-size: 0;
  }

  .dataList{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pack/feedback.vue